import * as React from 'react';

import { NodeProps, Position } from '@xyflow/react';
import { RefreshCw } from 'lucide-react';

import { BaseNode } from '../../BaseNode';
import type { FlowNode, NodeVisualDefinition } from '../../types';

import { LoopConfigType, getLoopPreviewText } from './schema';

/** Typed node for loop */
type LoopNodeType = FlowNode<LoopConfigType>;

/** Visual definition for the Loop node */
export const loopVisualDefinition: NodeVisualDefinition = {
  key: 'Loop',
  label: 'Loop',
  description: 'Iterate over array items',
  icon: RefreshCw,
  color: 'rust',
  handles: [
    {
      type: 'target',
      position: Position.Top,
      className: 'bg-gray!',
    },
    {
      type: 'source',
      position: Position.Bottom,
      className: 'bg-gray!',
    },
  ],
  getContent: getLoopPreviewText as (config: Record<string, unknown>) => string,
};

/**
 * Visual component for Loop nodes on the canvas.
 * Uses BaseNode with single input/output - executes children for each array item.
 */
export const LoopNode = React.memo<NodeProps<LoopNodeType>>((props) => (
  <BaseNode
    {...props}
    definition={loopVisualDefinition}
    className="@LoopNode"
  />
));

LoopNode.displayName = 'LoopNode';
